import React,{ Component } from 'react';
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormText
 } from 'reactstrap';

import Button from '../../../shared/components/Button';
import PhonePreview from '../../../shared/components/PhonePreview';
import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import ColorInput from '../../../shared/components/ColorInput';

class EditBrand extends Component {
  constructor(){
    super();

    this.state = {
      name:null,
      colorValid:true,
      color:null,
      logoURL:null,
      logoThumbnailURL:null,
      logoFileName:null,
      logoId:null,
      isUpdating:false,
      error:null,
      validationMessages:{}
    }
  }

  componentWillMount(){

    if(this.props.primaryColor){
      this.setState({color:this.props.primaryColor});
    }

    if(this.props.logoURL){
      this.setState({logoURL:this.props.logoURL});
    }

    if(this.props.name){
      this.setState({name:this.props.name});
    }

    if(this.props.logoFileName){
      this.setState({logoFileName:this.props.logoFileName})
    }
  }

  handleColorChange(color){
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

    if(isValid){
      this.setState({
        color:color,
        colorValid:isValid
      })
    } else {
      this.setState({colorValid:isValid})
    }
  }

  handleLogoChange(logos){
    this.setState({
      logoId:logos.id,
      logoThumbnailURL:logos.thumbnail,
      logoFileName:logos.fileName,
      logoURL:logos.large,
      error:null
    });
  }

  handleNameChange(name){
    this.setState({
      name:name,
      error:null
    });
  }

  handleSubmit(data){
    const dataWithImages = {
      logoId:this.state.logoId,
      logoURL:this.state.logoURL,
      primaryColor:this.state.color,
      logoThumbnailURL:this.state.logoThumbnailURL,
      logoFileName:this.state.logoFileName,
      ...data
    };

    const validationMessages = {}

    if(!dataWithImages.name || dataWithImages.name === ''){
      validationMessages['name'] = 'Name is required';

    } 

    if(!dataWithImages.contactUserId){
      validationMessages['contact'] = 'Contact is required';

    } 

    if(!dataWithImages.primaryColor){
      validationMessages['primaryColor'] = 'Color is required';

    } 

    if(!dataWithImages.logoURL){
      validationMessages['logo'] = 'Logo is required';
    }

    //HACK TO AVOID NAME BEING NULL
    if(!data.name){
      data.name = "";
    }


    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      this.setState({isUpdating:true});

      if(this.props.isCreate){
        this.props.createBrand({
          agencyId:this.props.agencyId,
          isBrand:true,
          active:true,
          ...dataWithImages
        })
          .then((res) => this.handleSuccess())
          .catch((err) => this.handleFailure(err));
      } else {
        this.props.updateBrand(this.props.brandId,dataWithImages)
          .then((res) => this.handleSuccess())
          .catch((err) => this.handleFailure(err));
      }
    }
  }

  handleSuccess(){
    this.setState({isUpdating:false});
    this.props.history.push(this.getBackLink());
  }

  handleFailure(err){
    this.setState({error:err});
  }

  getSubmitText(){
    if(this.state.isUpdating && this.props.isCreate){
      return 'Creating';
    } else if(this.state.isUpdating){
      return 'Updating';
    } else if(this.props.isCreate){
      return 'Create';
    } else {
      return 'Update';
    }
  }

  getBackLink(){
    return this.props.match.url.substring(0,this.props.match.url.lastIndexOf('/'));
  }

  render(){
    const {
      isCreate,
      name,
      primaryColor,
      contactUserId,
      users
    } = this.props;

    const {
      isUpdating,
      colorValid,
      logoFileName,
      logoURL,
      validationMessages
    } = this.state;

    return (
      <Container className='EditBrand'>
        <Row>
          <Col xs='6'>
            <br />
            <br />
            <br />
            <h3>{isCreate ? 'Create Brand' : `Edit ${name}`}</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='6'>
            <p>
              Assign a brand name and logo for your consumers to view while engaging with your experiences.  We'll filter reporting based on brand to help organize your data.
            </p>
            <br />
            <Form onSubmit={this.handleSubmit.bind(this)}>
              <Row>
                <Col xs='12'>
                  <TextInput
                    name='name'
                    label='Name'
                    defaultValue={name}
                    onChange={(name) => this.handleNameChange(name)}
                    maxLength={40}
                    warning={validationMessages['name']}
                  />
                  <FormGroup>
                    <Label>
                      Contact
                    </Label>
                    <Input
                      type='select'
                      name='contactUserId'
                      defaultValue={contactUserId}
                    >
                      {users.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.firstName} {user.lastName}
                        </option>
                      ))}
                    </Input>
                    {validationMessages['contact'] && (
                      <FormText className='DangerFeedback'>{validationMessages['contact']}</FormText>
                    )}
                  </FormGroup>
                  <FormGroup color={colorValid ? '' : 'danger'}>
                    <Label>
                      Color
                    </Label>
                    <ColorInput
                      name='primaryColor'
                      defaultValue={primaryColor}
                      placeholder='#FF00FF'
                      onChange={this.handleColorChange.bind(this)}
                      warning={validationMessages['primaryColor']}
                    />
                  </FormGroup>
                  <DroppableFileInput 
                    text='Upload Brand Logo'
                    fileType='image'
                    onChange={(logo) => this.handleLogoChange(logo)}
                    cropperAspectRatio={1/1}
                    existingFileName={logoFileName}
                    existingFileURL={logoURL}
                    warning={validationMessages['logo']}
                  />
                </Col>
              </Row>
              <br />
              <div>
                <Button
                  isSubmit
                  disabled={isUpdating}
                >
                  {this.getSubmitText()}
                </Button>
                <Button
                  linkHref={this.getBackLink()}
                  className='float-right'
                  textColor='#666666'
                  borderColor='#cccccc'
                  backgroundColor='#ededed'
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Col>
          <Col xs={{size:4,offset:1}}>
            <div style={{marginLeft:15}}>
              <PhonePreview
                hideTotalValue
                height={400}
                phonePlatform='generic'
                conclusionText={'Look for us at your favorite store!'}
                conclusionBackgroundColor={this.state.color}
                conclusionCentsAddedToAccount={20}
                completionImageURL={require('../../../shared/assets/image-4x3.png')}
                logoURL={this.state.logoURL || require('../../../shared/assets/image-1x1.png')}
                activeEngagementId='__CONCLUSION__'
                engagements={[]}
              />
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default EditBrand;



// WEBPACK FOOTER //
// ./src/routes/EditBrand/components/EditBrand.js